import { propertyValue } from './dood-block-config';
import { doodModalConfig } from './dood-modal-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PONGOOFFEREDPRODUCTPICKERMODAL_LEGACY_FIELD_ORDER = [
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  pongoOfferedProductPickerModalDescriptor: _generatedPongoOfferedProductPickerModalDescriptor,
  pongoOfferedProductPickerModalModalDefinition,
  pongoOfferedProductPickerModalDashboardLayout,
  pongoOfferedProductPickerModalConfig,
  pongoOfferedProductPickerModalResolveConfig,
  pongoOfferedProductPickerModalProperties,
} = doodModalConfig(
  {
    name: "Pongo - Offered product picker modal",
    handle: "pongo-offered-product-picker-modal",
    internal_name: "PongoOfferedProductPickerModal",
    componentType: 'PongoOfferedProductPickerModalComponent',
    category: 'modal',
    description: "Pongo - Offered product picker modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "pongo-offered-product-picker-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function pongoOfferedProductPickerModalDescriptor(): IBlockDescriptor;
export function pongoOfferedProductPickerModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function pongoOfferedProductPickerModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPongoOfferedProductPickerModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPongoOfferedProductPickerModalDescriptor, pongoOfferedProductPickerModalProperties, fieldOrder);
}

export {
  pongoOfferedProductPickerModalModalDefinition,
  pongoOfferedProductPickerModalDashboardLayout,
  pongoOfferedProductPickerModalProperties,
  pongoOfferedProductPickerModalConfig,
  pongoOfferedProductPickerModalResolveConfig,
};

export type PongoOfferedProductPickerModalConfig = typeof pongoOfferedProductPickerModalConfig;
